import styled from 'styled-components'

import MEDIA from 'constants/media'


const FormColumnsWrap = styled.div`
  max-width: 460px;
  margin: auto;
  margin: 30px auto;
  ${MEDIA.medium`
    display: flex;
    justify-content: space-between;
    > div {
        max-width: 220px;
        margin: 0;
        &:last-of-type {
          margin: 0;
        }
      }
  `}
`

export default FormColumnsWrap
